module.exports = __webpack_public_path__ + "polymerPostit.svg?ce66f63a98cb0805b73a9a0626ee5bc3";